export default __webpack_public_path__ + "static/media/clock.bdd2eb32.svg";